<template>
  <NLoadingBarProvider :loading-bar-style="loadingBarStyle" >
    <LoadingBar />
    <NMessageProvider :placement="'top-right'">
      <Message />
      <slot></slot>
    </NMessageProvider>
  </NLoadingBarProvider>
</template>

<script setup>
import { NLoadingBarProvider, NMessageProvider } from "naive-ui";
import LoadingBar from "./LoadingBar.vue";
import Message from "./Message.vue";
const loadingBarStyle = {
  loading: { backgroundColor: "transparent" }
};
</script>

<style lang="scss">
:root {
  --n-color-loading: #213ce5;
}

.n-loading-bar {
  background: transparent !important;
  position: relative;
  overflow: visible;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #213ce5, #2380f2);
  }
}
</style>
